export const BROADCAST_CHANNELS = {
	ACTIVE_FACILITY: 'active-facility'
};

export default { BROADCAST_CHANNELS };
